<template>
  <div class="generic-filter">
        <div @click="collapse" class="title-container">
            <p class="title">{{filters.category}} <span v-if="selectedQtyFilters > 0">({{selectedQtyFilters}})</span></p>
            <p class="icon">{{plusIcon}}</p>
        </div>
        <div v-if="!collapsed && !isColor" class="checkbox-container">
            <div @click="addTag(categories.tag)" class="checkbox-button" v-for="categories of filters.filters" :key="categories.category">
                <input  :value="categories.tag" type="checkbox" v-model="activeFilters" @change="changeFilters()">
                <p>{{categories.value}}</p>
            </div>
        </div>
        <div v-if="!collapsed && isColor" class="button-container">
            <div :class="[activeFilters.find(x => x == categories.tag) ? 'selected' : '']" @click="addTag(categories.tag)" class="color-button" v-for="categories of filters.filters" :key="categories.category">
                <div :style="'background:' + getColor(categories.tag)" class="round-color"></div>
                <p>{{categories.value}}</p>
            </div>
        </div>
  </div>
</template>

<script>
import smoothReflow from 'vue-smooth-reflow'
export default {
    mixins: [smoothReflow],
    props:{
        filters: Object,
        filteredAddons: Array
    },
    data() {
        return{
            collapsed: true,
            activeFilters: [],
            activeRadio: "",
        }
    },
    computed: {
        selectedFilters: {
            get(){ return this.$store.state.selectedFiltersMobile },
            set(value){this.$store.commit('setSelectedFiltersMobile',  value)}
        },
        plusIcon(){
            return this.collapsed == true ? '+' : '-';
        },
        isColor(){
            return this.filters.category.toLowerCase() == "color"
        },
        selectedQtyFilters(){
            var filters = this.selectedFilters.find(x => x.title == this.filters.category);
            if(filters)
                return filters.filters.length
            return 0
        }
    },
    methods: {
        collapse(){
            this.collapsed = !this.collapsed;
        },
        changeFilters(){
            this.selectedFilters = { title:this.filters.category, filters:this.activeFilters };
        },
        getColor(tag){
           var data = tag.replace("Filter_","").split("_");
           if(data.length > 2){
               return data[2];
           }
           if(tag.includes("Multi"))
            return "linear-gradient(to left, #b7bfff 0 33%, #ffc8c4 33% 66%, #ffeeda 66% 100%);"

           return '#000'
        },
        addTag(tag){
            let currentIndex = this.activeFilters.findIndex(x => x == tag);
            if(currentIndex > -1){
                this.activeFilters.splice(currentIndex, 1);
            }
            else{
                this.activeFilters.push(tag);
            }
            this.changeFilters();
        },
    },
    mounted(){
        this.$smoothReflow();
    },
}
</script>

<style scoped>
.generic-filter{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: white;
    box-shadow: inset 0px -1px 0px #E6E8EC;
}

.icon{
    cursor: pointer;
    font-size: 1rem;
}

.title-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    padding: 2% 5%;
}
.title{
    color: #0F0C38;
    font-family: 'Karla';
    font-style: normal;
    font-weight: 700;
    font-size: 1.3vw;
    line-height: 1.5;
}

.checkbox-container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0% 0% 3% 5%;
    width: 100%;
    overflow: hidden;
}

.checkbox-button{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 1% 0%;
}

.checkbox-button p{
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 1.2vw;
    line-height: 1.43;
    color: #0F0C38;
}

.button-container{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    padding: 0% 0% 3% 5%;
    width: 100%;
    overflow: hidden;
    width: 100%;
    justify-content: space-around;
}

.color-button{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 4px 8px;
    background: #F3F4F6;
    border-radius: 100px;
    width: 40%;
    cursor: pointer;
    margin-bottom: 5%;
}

.color-button.disabled{
    opacity: 0.6;
}

.color-button.selected{
    border: 1px solid #0F0C38;
}

.checkbox-button input{
    height: unset !important;
}

.color-button p{
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 1.2vw;
    line-height: 1.43;
    color: #3F3D60;
}

.round-color{
    width: 1.5vw;
    height: 1.5vw;
    border-radius: 100px;
}

@media screen and (max-width: 767px){
    .title{
        font-size: 1.2rem;
    }

    .icon{
        font-size: 2rem;
    }

    .button-container{
        justify-content: flex-start;
    }

    .color-button{
        justify-content: space-around;
        width: 30%;
        margin-right: 3%;
    }

    .round-color{
        width: 1.5rem;
        height: 1.5rem;
    }
    .checkbox-button p,.color-button p{
        font-size: 1rem;
    }
}
</style>